<template>
  <div>
    <v-row>
      <v-col cols="12" class="">
        <v-row>
          <v-col cols="4" class="pb-0">
            <v-select class="input-text-size" label="Tax Year"
              :readonly="!isSuperAdmin"
            :items="taxYearList" v-model="editedItem.taxYear">
            </v-select>
          </v-col>
          <v-col cols="8" class="pb-0">
            <v-text-field class="input-text-size"
            v-uppercase=globalSettingItem.conEverythingToCaps
            label="Tax District Code - Tax District Name/Description"
              :readonly="!isSuperAdmin"
              v-model="editedItem.schoolDistrict">
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Original Tax Amount"
          :readonly="!isSuperAdmin"
        v-model.number="editedItem.originalTax"
          id="originalTax" autofocus @blur="roundAmount();"
          @focus="amountToNum($event), $event.target.select()">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Adjusted Tax Amount"
        v-model.number="editedItem.adjTax" readonly
          autofocus id="adjTax" @blur="roundAmount();"
          @focus="amountToNum($event), $event.target.select()">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size"
          :readonly="!isSuperAdmin"
        label="Supplements Added" v-model.number="editedItem.supplements"
        id="supplements"
          autofocus @blur="roundAmount();" @focus="amountToNum($event), $event.target.select()">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Taxes Collected"
        id="collections"
        v-model.number="editedItem.collections" autofocus
          :readonly="!isSuperAdmin"
          @blur="roundAmount();" @focus="amountToNum($event), $event.target.select()">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Positive Adjustments"
          :readonly="!isSuperAdmin"
        v-model.number="editedItem.plusAdj" autofocus
        id="plusAdj"
          @blur="roundAmount();" @focus="amountToNum($event), $event.target.select()">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Taxes Held in Protest"
          :readonly="!isSuperAdmin"
        v-model.number="editedItem.protest"
        id="protest"
          autofocus @blur="roundAmount();" @focus="amountToNum($event), $event.target.select()">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Negative Adjustments"
          :readonly="!isSuperAdmin"
         v-model.number="editedItem.minusAdj"
         id="minusAdj"
          autofocus @blur="roundAmount();" @focus="amountToNum($event), $event.target.select()">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Taxes Overpaid"
          :readonly="!isSuperAdmin"
        v-model.number="editedItem.overpaid" autofocus
        id="overpaid"
          @blur="roundAmount();" @focus="amountToNum($event), $event.target.select()">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Adjusted Tax Amount"
          :readonly="!isSuperAdmin"
        v-model.number="editedItem.adjTax" autofocus
        id="adjTax"
          @blur="roundAmount();" @focus="amountToNum($event), $event.target.select()">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Total Uncollected"
          :readonly="!isSuperAdmin"
         v-model.number="editedItem.uncollected"
         id="uncollected"
          autofocus @blur="roundAmount();" @focus="amountToNum($event), $event.target.select()">
        </v-text-field>
      </v-col>
    </v-row>
    <div class="d-flex flex-row justify-space-around">
      <v-btn color="primary" dense small @click="handleReTotal" v-if="isSuperAdmin"
      :disabled="disableReTotal">Re-Total from Taxroll</v-btn>
      <v-btn color="primary" dense small @click="handleRecalculate">
        Recalculate
      </v-btn>
    </div>
  </div>
</template>

<script>
import {
  mapGetters, mapState,
  mapMutations,
} from 'vuex';
import { amountFormat, amountToNumber, focusAmount } from '../../../util/shared/vue-global';
import { isAuthorised } from '../../../store/auth/token';
import { authRoles } from '../../../router/roleGroups';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

const amountFields = [
  'originalTax', 'supplements', 'plusAdj', 'minusAdj', 'uncollected', 'adjTax', 'overpaid', 'collections', 'protest',
];

export default {
  name: 'taxRollSummaryDialog',
  mixins: [GlobalToCaps],
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxMortgageCodesList',
    },
    disableReTotal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {

    };
  },

  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    ...mapState({
      taxYearList: (state) => state.tax.taxCommon.taxYearList,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    isSuperAdmin() {
      return isAuthorised(authRoles.SuperAdmin);
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    focusAmount,
    amountFormat,
    adjTaxAmount() {
      const {
        originalTax, supplements, plusAdj, minusAdj,
      } = this.editedItem;
      return amountToNumber(originalTax) + amountToNumber(supplements)
        + amountToNumber(plusAdj) + (amountToNumber(minusAdj));
      // minusAdj is negative so for subtraction we need to add it
    },
    totalUncollected() {
      const { adjTax, collections } = this.editedItem;
      return amountToNumber(adjTax) - amountToNumber(collections);
    },
    handleReTotal() {
      this.$emit('handleReTotal', this.editedItem);
    },
    handleRecalculate() {
      this.editedItem.adjTax = amountFormat(this.adjTaxAmount());
      this.editedItem.uncollected = amountFormat(this.totalUncollected());
    },
    amountToNum(e) {
      this.editedItem[`${e.target.id}`] = amountToNumber(e.target.value);
    },
    roundAmount() {
      return amountFields.forEach((f) => {
        this.editedItem[f] = amountFormat(amountToNumber(this.editedItem[f]));
      });
    },
  },
};
</script>
